import React from 'react';
type ArtifactViewMainContentSignaturesComponentVersionPackageManagerBowerProps = {
  component: object;
  version: object;
};
const ArtifactViewMainContentSignaturesComponentVersionPackageManagerBower: React.SFC<
  ArtifactViewMainContentSignaturesComponentVersionPackageManagerBowerProps
> = props => {
  let component = props.component,
    version = props.version;
  return (
    <div className="grid">
      <div className="grid__item col-1-1 pl0">Package:</div>
      <div className="grid__item col-1-1 pt-- pl0">
        <div className="font-family--code bg-color--black-dark p- color--white phone--font--h7 phone--no-overflow">
          "{component.name}": "{version.version}"
        </div>
      </div>

      <div className="grid__item col-1-1 pt- pl0">Install:</div>
      <div className="grid__item col-1-1 pt-- pl0">
        <div className="font-family--code bg-color--black-dark p- color--white phone--font--h7 phone--no-overflow">
          bower install {component.name}@{version.version}
        </div>
      </div>
    </div>
  );
};
export default ArtifactViewMainContentSignaturesComponentVersionPackageManagerBower;
